import { render } from "./activityScale.vue?vue&type=template&id=4f3dea18&scoped=true"
import script from "./activityScale.vue?vue&type=script&lang=js"
export * from "./activityScale.vue?vue&type=script&lang=js"

import "./activityScale.vue?vue&type=style&index=0&id=4f3dea18&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3dea18"]])

export default __exports__